import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { initialGuestInfo } from '@components/views/flight/constants';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';

import { IFlightSearchBarState } from './types/flight';
import { IHotelSearchBarState } from './types/hotel';
import { ITourSearchBarState } from './types/tour';
import { ICarRentalSearchBarState } from './types/car';

export interface ISearchBar {
  flight: IFlightSearchBarState;
  hotel: IHotelSearchBarState;
  tour: ITourSearchBarState;
  car: ICarRentalSearchBarState;
}

export const INITIAL_FLIGHT_VALUES = {
  startDate: moment(),
  endDate: null,
  guestInfo: initialGuestInfo,
  isOneWay: false,
  isDirectFlight: true,
  isValidFlightSearchBar: false,
  isSubmit: false,
  cabinClass: 'All' as IFlightSearchBarState['cabinClass'],
  arrivalAirport: null,
  departureAirport: null,
  isDrawerOpen: false,
  isArrivalError: false,
  isDepartureError: false,
};

export const INITIAL_ROOMS: ListingSearchRoomInterface[] = [
  {
    adultCount: 2,
    childrenList: [],
    closable: true,
    error: false,
    id: uuidv4(),
    key: '1',
    title: '1. Oda',
  },
];

export const INITIAL_HOTEL_VALUES = {
  location: null,
  isLocationError: false,
  rooms: INITIAL_ROOMS,
  checkDates: null,
  isCheckDatesError: false,
  isDrawerOpen: false,
  isHotelDateSelected: false,
};
export const INITIAL_TIME = '13:00';
export const INITIAL_LOCATION = {
  atTheAirport: false,
  code: '',
  id: '',
  name: '',
  providerIds: [],
};

export const INITIAL_CAR_VALUES = {
  pickUpDate: null,
  dropOffDate: null,
  pickUpTime: '',
  dropOffTime: '',
  dropOffLocation: null,
  pickUpLocation: null,
  providerIds: [],
  isDifferentLocation: false,
  errors: {
    pickUpDate: false,
    dropOffDate: false,
    pickUpTime: false,
    dropOffTime: false,
    dropOffLocation: false,
    pickUpLocation: false,
  },
};

export const INITIAL_TOUR_VALUES = {
  searchData: null,
  href: '',
  isSearchDataError: false,
};

export const INITIAL_VALUES = {
  flight: INITIAL_FLIGHT_VALUES,
  hotel: INITIAL_HOTEL_VALUES,
  tour: INITIAL_TOUR_VALUES,
  car: INITIAL_CAR_VALUES,
};
